import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d87e0f0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gio-stats-wrapper" }
const _hoisted_2 = { class: "landing-page-container" }
const _hoisted_3 = { class: "gio-stats" }
const _hoisted_4 = {
  class: "contentWrapper",
  ref: "sectionRef"
}
const _hoisted_5 = { class: "contentDigit" }
const _hoisted_6 = { class: "contentTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allInfo, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content",
              key: item.id
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatNumber(item.count)) + "+", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1)
            ]))
          }), 128))
        ], 512)
      ])
    ])
  ]))
}